import * as React from "react";
import { Bell, BellOff } from "lucide-react";
import { toast } from "sonner";
import { Switch } from "@/components/ui/switch";
import {
  getExistingSubscription,
  getVapidPublicKey,
  pushSupported,
  subscribeToPush,
  unsubscribeFromPush
} from "@/lib/api/push";

export function PushNotificationsToggle() {
  const [enabled, setEnabled] = React.useState(false);
  const [busy, setBusy] = React.useState(false);
  const supported = pushSupported() && !!getVapidPublicKey();

  React.useEffect(() => {
    if (!supported) return;
    void getExistingSubscription().then((sub) => setEnabled(!!sub));
  }, [supported]);

  if (!supported) {
    return (
      <div className="rounded-lg border border-slate-200 bg-white p-3 text-xs text-slate-600 dark:border-slate-800 dark:bg-slate-950 dark:text-slate-400">
        Push értesítések ehhez a böngészőhöz / telepítéshez nem elérhetők
        {!getVapidPublicKey() ? " (hiányzó VAPID kulcs)." : "."}
      </div>
    );
  }

  return (
    <div className="flex items-center justify-between gap-3 rounded-lg border border-slate-200 bg-white p-3 dark:border-slate-800 dark:bg-slate-950">
      <div className="min-w-0 flex items-start gap-2">
        {enabled ? (
          <Bell className="mt-0.5 h-4 w-4 shrink-0 text-amber-600" aria-hidden />
        ) : (
          <BellOff className="mt-0.5 h-4 w-4 shrink-0 text-slate-400" aria-hidden />
        )}
        <div className="min-w-0">
          <div className="text-sm font-medium text-slate-900 dark:text-slate-50">Értesítések</div>
          <p className="text-xs text-slate-600 dark:text-slate-400">Új feladat / státusz / cím változás</p>
        </div>
      </div>
      <Switch
        checked={enabled}
        disabled={busy}
        data-testid="push-notifications-toggle"
        onCheckedChange={(next) => {
          void (async () => {
            setBusy(true);
            try {
              if (next) {
                await subscribeToPush();
                setEnabled(true);
                toast.success("Értesítések bekapcsolva");
              } else {
                await unsubscribeFromPush();
                setEnabled(false);
                toast.message("Értesítések kikapcsolva");
              }
            } catch (e) {
              toast.error(e instanceof Error ? e.message : "Nem sikerült az értesítés beállítása");
              setEnabled(false);
            } finally {
              setBusy(false);
            }
          })();
        }}
      />
    </div>
  );
}
